import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "sorrol_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Share only in-flight reads, never cache private data or a completed list.
const pendingReads = new Map();
export function dedupedGet(url) {
  const key = `${localStorage.getItem(TOKEN_KEY) || "guest"}:${url}`;
  if (!pendingReads.has(key)) {
    const request = api.get(url).finally(() => {
      if (pendingReads.get(key) === request) pendingReads.delete(key);
    });
    pendingReads.set(key, request);
  }
  return pendingReads.get(key);
}
api.interceptors.response.use((response) => {
  if (response.config.method !== "get") pendingReads.clear();
  return response;
});

export const homeContentQuery = {
  queryKey: ["home-content"],
  queryFn: () => dedupedGet("/content/home").then((response) => response.data || {}),
  staleTime: 30_000,
};

export function apiErrorMsg(detail) {
  if (detail == null) return "Valami hiba történt. Kérjük, próbáld újra.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
